<template>
    <div class="d-flex justify-content-center" id="itb-graphics-paginator">
        <button
            :disabled="currentPage === 1"
            @click="previousPage()"
            class="itb-page-left"
        >
            <img
                src="/images/icons/4soft_icon_angle-left-gray.svg"
                alt="prev"
                class="itb-icon"
                v-if="currentPage === 1"
            />
            <img
                src="/images/icons/4soft_icon_angle-left-blue.svg"
                alt="prev"
                class="itb-icon"
                v-else
            />
        </button>
        <button
            v-for="page in pages"
            @click="changeToPage(page)"
            class="itb-page-link btn btn-light"
            :class="{ 'itb-page-link-active': page == currentPage }"
        >
            {{ page }}
        </button>
        <button
            v-if="items[0]"
            :disabled="currentPage >= Math.ceil(total / numItemsPerPage)"
            @click="nextPage()"
            class="itb-page-right"
        >
            <img
                src="/images/icons/4soft_icon_angle-right-gray.svg"
                alt="next"
                class="itb-icon"
                v-if="currentPage >= Math.ceil(total / numItemsPerPage)"
            />
            <img
                src="/images/icons/4soft_icon_angle-right-blue.svg"
                alt="next"
                class="itb-icon"
                v-else
            />
        </button>
    </div>
</template>

<script>
export default {
    props: ["items", "total", "numItemsPerPage", "pageNumber", "loadPageLinks"],
    name: "Paginator",
    data() {
        return {
            currentPage: 1,
            displayedPages: 5,
            pages: []
        };
    },
    mounted() {
        // this.$emit("getter", {
        //     page: this.currentPage,
        // });
        this.populatePageLinks();
    },

    watch: {
        pageNumber(val) {
            this.currentPage = val;
        },
        loadPageLinks(val) {
            this.populatePageLinks();
        }
    },
    methods: {
        nextPage() {
            this.currentPage++;
            this.$emit("getter", {
                page: this.currentPage,
                itemsPerPage: this.numItemsPerPage
            });
            this.populatePageLinks();
        },
        previousPage() {
            this.currentPage--;
            this.$emit("getter", {
                page: this.currentPage,
                itemsPerPage: this.numItemsPerPage
            });
            this.populatePageLinks();
        },

        populatePageLinks() {
            var maxPages = Math.ceil(this.total / this.numItemsPerPage);

            if (
                this.currentPage <=
                    this.displayedPages - Math.floor(this.displayedPages / 2) &&
                this.displayedPages >= maxPages
            ) {
                var firstPage = 1;
                var lastPage = maxPages;
            } else if (
                this.currentPage <=
                    this.displayedPages - Math.floor(this.displayedPages / 2) &&
                this.displayedPages < maxPages
            ) {
                var firstPage = 1;
                var lastPage = this.displayedPages;
            } else if (
                this.currentPage >
                    this.displayedPages - Math.floor(this.displayedPages / 2) &&
                this.currentPage <=
                    maxPages - Math.floor(this.displayedPages / 2)
            ) {
                var firstPage =
                    this.currentPage - Math.floor(this.displayedPages / 2);
                var lastPage =
                    this.currentPage + Math.floor(this.displayedPages / 2);
            } else {
                var firstPage = maxPages - this.displayedPages + 1;
                if (firstPage < 1) {
                    firstPage = 1;
                }
                var lastPage = maxPages;
            }

            this.pages = [...Array(lastPage - firstPage + 1).keys()].map(
                x => x + firstPage
            );
        },

        changeToPage(page) {
            this.currentPage = page;
            this.$emit("getter", {
                page: this.currentPage,
                itemsPerPage: this.numItemsPerPage
            });
            this.populatePageLinks();
        }
    }
};
</script>
<style></style>
